"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteProductFromRiseupAccountRequest = exports.DeleteProductFromRiseupAccountMarker = void 0;
const z = require("zod");
const RiseupAccount_1 = require("./RiseupAccount");
const UtilTypes_1 = require("./UtilTypes");
exports.DeleteProductFromRiseupAccountMarker = z.object({
    riseupAccountId: RiseupAccount_1.RiseupAccountId,
    requestedAt: UtilTypes_1.DateString,
    product: RiseupAccount_1.RiseupProduct,
    immediate: z.boolean().default(false),
    created: UtilTypes_1.DateString,
});
exports.DeleteProductFromRiseupAccountRequest = z.object({
    riseupAccountId: RiseupAccount_1.RiseupAccountId,
    requestedAt: UtilTypes_1.DateString,
    product: RiseupAccount_1.RiseupProduct,
    immediate: z.boolean().default(false),
});
//# sourceMappingURL=DeleteProduct.js.map